<template>
  <div class="medical-detail-cntainer">
    <TopBg title="IT服务流程管理系统" sub-title="聚焦IT管理落实，着力制度流程化！" :bg="topBg" />
    <div class="main-content page">
      <!-- 痛点分析 -->
      <div class="section">
        <div class="title">痛点分析</div>
        <div class="rows-4 m-rows-2">
          <PainsAnalysisItem desc="处理流程不规范">
            <template #icon>
              <img src="./assets/pain01.svg" alt="" />
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem desc="任务进展难把控">
            <template #icon>
              <img src="./assets/pain02.svg" alt="" />
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem desc="工作成果难量化">
            <template #icon>
              <img src="./assets/pain03.svg" alt="" />
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem desc="知识经验难传承">
            <template #icon>
              <img src="./assets/pain04.svg" alt="" />
            </template>
          </PainsAnalysisItem>
        </div>
      </div>

      <!-- 解决方案 -->
      <div class="section">
        <div class="title">解决方案</div>
        <div class="card">
          <SolutionItemV2 title="智能工单管理" desc="IVR+AI双核引擎:IVR精准分流，急事急办;AI智能建单、派单、推荐，告别低效!">
            <template #icon>
              <img src="./assets/solution01.svg" alt="" />
            </template>
          </SolutionItemV2>
          <div class="mt-16 border radius-8">
            <div class="example-title">某医院案例</div>
            <div class="p-16">

            <div class="rows-2">
              <div class="example-item">
                <div class="example-item-title">“急慢不分”的排队</div>
                <div class="example-item-desc">最急迫的需求被淹没在普通咨询电话中，临床怨声载道。</div>
              </div>
                <div class="example-item">
                <div class="example-item-title">“报修建单”之困</div>
                <div class="example-item-desc">平均建单耗时长达15分钟/件。</div>
              </div>
            </div>
             <div class="rows-2 border-top-dash pt-16 mt-16">
              <div class="example-item">
                <div class="example-item-title">“重复低效”的沟通</div>
                <div class="example-item-desc">同一个报修多次来电被多个热线员接听，重复描述，临床感到“信息科效率低”。</div>
              </div>
                <div class="example-item">
                <div class="example-item-title">“经验依赖”式处置</div>
                <div class="example-item-desc">故障解决依赖工程师个人记忆，知识无法沉淀共享。</div>
              </div>
            </div>
            </div>
          </div>
          <div class="flex mt-16">
            <el-image :src="solutionImg11" :preview-src-list="[solutionImg11]" />
          </div>
        </div>

        <div class="card mt-16">
          <SolutionItemV2 title="数字化机房巡检" subTitle="智能巡检，释放“生产力”" desc="一物一码、自动填单、一键报修，不止于无纸化，更是数字化转型的战略升级。">
            <template #icon>
              <img src="./assets/solution02.svg" alt="" />
            </template>
          </SolutionItemV2>
          <div class="flex mt-16">
            <el-image :src="solutionImg21" :preview-src-list="[solutionImg21]" />
          </div>
        </div>

        <div class="card mt-16">
          <SolutionItemV2 title="项目全生命周期管理"
            desc="提供项目全流程管理，包含项目基本信息管理、供应商管理、任务管理、需求管理、合同管理、发票管理、过程文档管理、过程会议管理等功能模块，切实解决项目进度完成结果难把控及项目工作任务无法量化的实际问题。">
            <template #icon>
              <img src="./assets/solution03.svg" alt="" />
            </template>
          </SolutionItemV2>
          <div class="flex-1 mt-16">
            <el-image :src="solutionImg31" :preview-src-list="[solutionImg31]" class="h-100"
              style="display: flex; align-items: stretch;" />
          </div>
        </div>

        <div class="card mt-16">
          <SolutionItemV2 title="AI运维知识库" subTitle="IT运维“智能专家”，让“个人能力”转为“科室能力”"
            desc="Al动态学习+专属运维知识库+智能检索，从碎片到体系，沉淀智慧资产，赋能运维生态。">
            <template #icon>
              <img src="./assets/solution04.svg" alt="" />
            </template>
          </SolutionItemV2>
          <div class="mt-16">
            <el-image :src="solutionImg41" :preview-src-list="[solutionImg41]" />
          </div>
        </div>
      </div>

        <!-- 解决方案 -->
      <div class="section">
        <div class="title">解决方案</div>
        <div class="rows-4">
          <SolutionItem title="值班考勤管理" desc="通过便捷的拖拉拽方式管理每日值班人员，自动关联工单，并以日历的形式直观呈现工作日、节假日值班情况。同时，记录员工的出勤、休假、请假和旷工情况，多维度统计员工考勤内容，辅助考评员工的工作情况。">
            <template #icon>
              <img src="./assets/solution11.svg" alt="" />
            </template>
          </SolutionItem>
          <SolutionItem title="数字化台账管理" desc="自定义台账文档分级分类管理，支持在线预览、在线下载等功能，帮助用户快速找到所需材料。">
            <template #icon>
              <img src="./assets/solution12.svg" alt="" />
            </template>
          </SolutionItem>
          <SolutionItem title="工作日志管理" desc="以日报、周报、月报、季报等形式汇报工作进展，从工作计划、完成情况、延期工作等维度自动生成工作报告。">
            <template #icon>
              <img src="./assets/solution13.svg" alt="" />
            </template>
          </SolutionItem>
            <SolutionItem title="会议记录管理" desc="会前管理会议基本信息与消息提醒，会中线上签到与线下补签等多种签到模式，会后生成会议纪要与在线打印。">
            <template #icon>
              <img src="./assets/solution14.svg" alt="" />
            </template>
          </SolutionItem>
        </div>
      </div>

      <!-- 产品特色 -->
      <div class="section">
        <div class="title">产品特色</div>
        <div class="rows-3">
          <FeatureItem title="智能工单(AI+IVR) ">
            <template #icon>
              <img src="./assets/feature01.svg" alt="" />
            </template>
          </FeatureItem>
          <FeatureItem title="AI知识库">
            <template #icon>
              <img src="./assets/feature02.svg" alt="" />
            </template>
          </FeatureItem>
          <FeatureItem title="信创国产化">
            <template #icon>
              <img src="./assets/feature03.svg" alt="" />
            </template>
          </FeatureItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBg from "../../common/TopBg.vue";
import SolutionItemV2 from "../../common/solution-item_v2.vue";
import SolutionItem from "../../common/solution-item.vue";
import PainsAnalysisItem from "../../common/pains-analysis-item.vue";
import FeatureItem from "@/components/common/feature-item.vue";

export default {
  name: "DrgPlatform",
  components: {
    TopBg,
    FeatureItem,
    SolutionItem,
    SolutionItemV2,
    PainsAnalysisItem,
  },
  data() {
    return {
      topBg: require("./assets/bg.png"),
      solutionImg11: require("./assets/solution11.png"),
      solutionImg21: require("./assets/solution21.png"),
      solutionImg31: require("./assets/solution31.png"),
      solutionImg41: require("./assets/solution41.png"),
    };
  },
};
</script>
